import React, {Component, Fragment} from 'react';
import {Input, InputGroup, InputGroupAddon, InputGroupText} from 'reactstrap';
import AttachmentList from 'catalog/containers/AttachmentList';
import {connect} from 'react-redux';
import * as measures from 'catalog/actions/measures';
import autobind from 'autobind-decorator';
import {MeasureTags} from 'catalog/components/MeasureTags';
import DeleteMeasure from 'catalog/components/DeleteMeasure';

@connect(
    null,
    dispatch => ({
        updateMeasure: (measure) => dispatch(measures.updateMeasure(measure)),
        change: (measure) => dispatch(measures.change(measure))
    })
)
export default class MeasureComponent extends Component {
    @autobind
    changeMeasureName(e) {
        this.props.change(
            {...this.props.measure, name: e.target.value, changed: true}
        )
    }

    @autobind
    updateMeasure() {
        this.props.updateMeasure(this.props.measure);
    }

    render() {
        const id = this.props.id;
        const {measure} = this.props
        return (
            <Fragment>
                <li className={'mt-3 mb-3'}>
                    <InputGroup>
                        <InputGroupAddon addonType='prepend'>
                            <InputGroupText>
                                {id + 1}.
                            </InputGroupText>
                        </InputGroupAddon>
                        <Input type="textarea" onChange={this.changeMeasureName} onBlur={this.updateMeasure}
                               value={measure.name}/>
                        <InputGroupAddon addonType='append'>
                            <MeasureTags measure={measure}/>
                            <DeleteMeasure measure={measure}/>
                        </InputGroupAddon>
                    </InputGroup>
                </li>
                <li style={{'marginBottom': '1em', marginTop: '1em'}}>
                    <AttachmentList measure={measure}/>
                </li>
            </Fragment>

        )
    }
}

